import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { doorEntityTotalsSelector, showDoorControllerAggregateTotalsSelector,
  doorControllerAggregateTotalsSelector } from 'selectors/components'
import toTitle from 'helpers/accessControl/toTitle'
import tippy from 'tippy.js'

function mapStateToProps(state, ownProps) {
  return {
    totals: doorEntityTotalsSelector(state, ownProps),
    showAggregateTotals: ownProps.isController && showDoorControllerAggregateTotalsSelector(state),
    aggregateTotals: ownProps.isController && doorControllerAggregateTotalsSelector(state)
  }
}

class ConfigurationSummary extends React.Component {
  componentDidMount = _ => tippy(`.${this.props.classes.helpIcon}`, { duration: 0, theme: 'topbar', placement: 'bottom' })

  render() {
    const { totals, isExport, isController, showAggregateTotals, aggregateTotals, classes, style } = this.props

    return (
      <div
        className={isExport ? (isController ? classes.exportContainer : classes.doorExportContainer) : classes.container}
        style={style}
      >
        { isExport && <strong>{isController ? 'Device Summary:' : 'Summary:'}</strong> }
        { (Object.keys(totals).length > 0 || (showAggregateTotals && Object.keys(aggregateTotals).length > 0))
          ? <table className={isExport ? classes.exportTable : classes.table} cellSpacing='0'>
              <thead>
                <tr>
                  <th>Device Type</th>
                  <th>{ showAggregateTotals ? 'Direct Count' : 'Count' }</th>
                  { showAggregateTotals &&
                    <th>
                      Total Count
                      { !isExport &&
                        <a className={classes.helpIcon} title='Total usage across main controller and all expansion controllers'>
                          <FontAwesomeIcon icon='info-circle' />
                        </a>
                      }
                    </th>
                  }
                </tr>
              </thead>
              <tbody>
                { Object.keys(showAggregateTotals ? aggregateTotals : totals).map(key =>
                    <tr key={key}>
                      <td>{toTitle(key)}</td>
                      <td>{totals[key] || (showAggregateTotals && 0)}</td>
                      { showAggregateTotals && <td>{aggregateTotals[key]}</td> }
                    </tr>
                  )
                }
              </tbody>
            </table>
          : (isExport ? <span>No devices yet</span> : <em style={{ marginBottom: '.8rem' }}>No devices yet</em>)
        }
      </div>
    )
  }
}

export default connect(mapStateToProps)(injectSheet(style)(ConfigurationSummary))



// WEBPACK FOOTER //
// ./src/components/DoorEntityConfigurationSummary/index.js